import { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { FaUser, FaChevronDown } from "react-icons/fa";
import styles from "./Navbar.module.css";

export default function Navbar() {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeSubDropdown, setActiveSubDropdown] = useState(null);

  const wrapperRef = useRef(null);

  const isLogged = Boolean(localStorage.getItem("token"));
  const username = localStorage.getItem("username");

  // Закрытие при клике вне меню
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setActiveDropdown(null);
        setActiveSubDropdown(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className={styles.wrapper}>
      <div
        className={styles.navbar}
        ref={wrapperRef}
        onMouseLeave={() => {
          setActiveDropdown(null);
          setActiveSubDropdown(null);
        }}
      >
        <div className={styles.logoBlock}>
          <NavLink to="/">
            <img src="/AdvAES-logo.png" alt="logo" className={styles.logo} />
          </NavLink>
          <span className={styles.logoText}></span>
        </div>

        <nav className={styles.menu}>
          {/* HOME */}
          <div
            className={styles.dropdown}
            onMouseEnter={() => setActiveDropdown("home")}
          >
            <span className={styles.link}>
              Home <FaChevronDown className={styles.icon} />
            </span>

            {activeDropdown === "home" && (
              <div className={styles.dropdownMenu}>
                <NavLink to="/about-us">About us</NavLink>
                <NavLink to="/contact">Contact</NavLink>
                <NavLink to="/news">News</NavLink>
              </div>
            )}
          </div>

          {/* CONFERENCE */}
          <div
            className={styles.dropdown}
            onMouseEnter={() => setActiveDropdown("conference")}
          >
            <span className={styles.link}>
              Conference <FaChevronDown className={styles.icon} />
            </span>

            {activeDropdown === "conference" && (
              <div className={styles.dropdownMenu}>
                <NavLink to="/conference">About Conference</NavLink>
                <NavLink to="/conference/past-new">Past & Further</NavLink>
                <NavLink to="/conference/register">Participation</NavLink>
                <NavLink to="/conference/accommodation">Accommodation</NavLink>
              </div>
            )}
          </div>

          {/* JOURNAL */}
          <div
            className={styles.dropdown}
            onMouseEnter={() => {
              setActiveDropdown("journal");
              setActiveSubDropdown(null);
            }}
          >
            <span className={styles.link}>
              Journal <FaChevronDown className={styles.icon} />
            </span>

            {activeDropdown === "journal" && (
              <div className={styles.dropdownMenu}>
                {/* GUIDELINES (подменю) */}
                <div
                  className={styles.subDropdown}
                  onMouseEnter={() => setActiveSubDropdown("guidelines")}
                  onMouseLeave={() => setActiveSubDropdown(null)}
                >
                  <span className={styles.subLink}>
                    Guidelines <FaChevronDown className={styles.icon} />
                  </span>

                  {activeSubDropdown === "guidelines" && (
                    <div className={styles.subDropdownMenu}>
                      <NavLink to="/guidelines-for-authors">
                        Guidelines for Authors
                      </NavLink>
                      <NavLink to="/guidelines-for-reviewers">
                        Guidelines for Reviewers
                      </NavLink>
                    </div>
                  )}
                </div>

                <NavLink to="/ethics">Ethics</NavLink>
                <NavLink to="/EditorialBoard">Editorial Board</NavLink>
                <NavLink to="/about-journal">About Journal</NavLink>
              </div>
            )}
          </div>

          <NavLink to="/article-submission" className={styles.link}>
            Article submission
          </NavLink>
        </nav>

        {!isLogged ? (
          <button
            className={styles.signBtn}
            onClick={() => (window.location.href = "/sign-in")}
          >
            Sign up <FaUser className={styles.userIcon} />
          </button>
        ) : (
          <div className={styles.userBadge}>
            <FaUser /> {username || "User"}
          </div>
        )}
      </div>
    </header>
  );
}
